const call: (callBack?: (...params: any[]) => unknown, ...params: any[]) => unknown =
  (callBack, ...params) => callBack && callBack(...params)

export {
  call
}
